"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

const jsx_runtime_1 = require("react/jsx-runtime");

const SvgIgiLogo = props => (0, jsx_runtime_1.jsxs)("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 38.74,
  height: 38.739
}, props, {
  children: [(0, jsx_runtime_1.jsx)("defs", {
    children: (0, jsx_runtime_1.jsx)("clipPath", Object.assign({
      id: "igiLogo_svg__a"
    }, {
      children: (0, jsx_runtime_1.jsx)("path", {
        "data-name": "Rectangle 681",
        d: "M0 0h38.74v38.739H0z"
      }, void 0)
    }), void 0)
  }, void 0), (0, jsx_runtime_1.jsxs)("g", Object.assign({
    "data-name": "logo-for-title (1)"
  }, {
    children: [(0, jsx_runtime_1.jsx)("path", {
      "data-name": "Path 561",
      d: "M13.949 11.829l-4.395 3.288 9.748 8.753.027-.026h.082l9.774-8.674-4.225-3.325zm5.692 10.551l-8.253-7.424 3.284-2.446 9.7.014 3.466 2.671z",
      fill: "#8c7969"
    }, void 0), (0, jsx_runtime_1.jsx)("path", {
      "data-name": "Path 562",
      d: "M15.507 13.164l-3.017 2.227 6.965 6.167 7.037-6.3-2.823-2.079zm4.107 7.307l-5.749-5.182 2.317-1.742 7.051.009 2.234 1.852z",
      fill: "#8c7969"
    }, void 0), (0, jsx_runtime_1.jsx)("path", {
      "data-name": "Path 563",
      d: "M17.014 14.12l-2.077 1.47 4.524 4.038 4.653-4.082-1.88-1.419zm2.549 4.772l-3.572-3.191 1.589-1.223 4.336.006 1.345 1.118z",
      fill: "#8c7969"
    }, void 0), (0, jsx_runtime_1.jsx)("path", {
      "data-name": "Path 564",
      d: "M22.253 28.867l1.43-1.269.006-3.6-1.434 1.199z",
      fill: "#8c7969"
    }, void 0), (0, jsx_runtime_1.jsx)("path", {
      "data-name": "Path 565",
      d: "M14.951 28.855l1.428-1.269.006-3.6-1.436 1.206z",
      fill: "#8c7969"
    }, void 0), (0, jsx_runtime_1.jsx)("path", {
      "data-name": "Path 566",
      d: "M19.302 23.871l-2.713 2.581v2.425h2.893l2.506-2.485v-1.227h-1.16l1.351-1.314h-2.765l-.07.062zm1.47 1.293l-1.5 1.247h1.43v1.207h-2.7v-2.456h.145z",
      fill: "#8c7969"
    }, void 0), (0, jsx_runtime_1.jsx)("path", {
      "data-name": "Path 567",
      d: "M14.919 2.817l.1-.169.1-.169.122-.2.1-.159 1.05-1.757 1.538 1.352.139.122.179.158.148.13.148.13.855.751.856-.748.148-.13.148-.129.18-.157.14-.122L22.411.373l1.044 1.755.095.16.122.2.1.169.1.169.58.978 1.046-.447.181-.077.181-.078.22-.094.17-.073 1.883-.797.449 2 .041.181.052.233.043.192.044.192.249 1.109 1.134-.1.2-.018.2-.018.238-.021.185-.017 2.039-.184-.19 2.039-.017.185-.022.238-.018.2-.018.2-.106 1.132 1.109.253.192.044.192.044.233.053.181.041 2 .456-.81 1.88-.074.171-.094.219-.078.181-.078.18-.45 1.045.977.583.168.1.169.1.2.123.159.095 1.757 1.05-1.351 1.538-.123.139-.157.179-.13.148-.13.148-.751.855.748.856.13.148.13.148.158.18.122.14 1.335 1.531-1.761 1.044-.159.095-.205.122-.17.1-.169.1-.978.58.447 1.046.078.181.077.181.094.22.073.17.8 1.883-2 .449-.181.041-.233.052-.193.043-.192.043-1.11.25.1 1.132.018.2.018.2.021.238.017.185.183 2.038-2.038-.189-.185-.018-.237-.022-.2-.018-.2-.018-1.115-.11-.252 1.111-.048.189-.044.192-.053.233-.041.181-.455 2-1.88-.81-.17-.073-.22-.094-.181-.078-.181-.078-1.044-.45-.583.976-.1.169-.1.169-.123.205-.1.159-1.05 1.757-1.537-1.352-.139-.122-.18-.158-.148-.13-.148-.13-.854-.75-.857.749-.148.13-.149.129-.18.157-.14.122-1.542 1.347-1.045-1.761-.095-.159-.122-.206-.1-.17-.1-.169-.58-.978-1.046.446-.181.078-.181.077-.22.095-.171.073-1.883.8-.449-2-.041-.18-.052-.233-.043-.192-.043-.192-.249-1.11-1.133.1-.2.018-.2.018-.238.021-.185.017-2.039.183.19-2.038.017-.185.022-.238.018-.2.019-.2.105-1.132-1.108-.253-.192-.044-.192-.044-.233-.053-.181-.041-2-.455.81-1.88.074-.171.094-.219.078-.181.078-.181.45-1.045-.976-.583-.169-.1-.169-.1-.205-.122-.159-.1-1.757-1.05 1.352-1.537.122-.139.157-.179.13-.148.13-.148.751-.854-.749-.856-.129-.149-.13-.148-.157-.18-.122-.14L.37 16.33l1.761-1.045.159-.095.205-.122.17-.1.169-.1.978-.58-.449-1.05-.077-.181-.077-.181-.094-.219-.073-.17-.8-1.883 2-.45.181-.04.233-.053.193-.043.192-.043 1.109-.25-.1-1.133-.018-.2-.018-.2-.021-.238-.017-.185-.193-2.031 2.039.189.185.018.238.022.2.018.2.018 1.132.106L10.03 5l.044-.192.044-.192.053-.233.041-.181.455-2 1.881.811.17.073.219.095.181.078.181.078 1.044.45zM16.333 0l-1.19 1.991-.1.159-1.563-.988-.684 1.716-.17-.073-2.131-.918-.515 2.261-.041.181-1.792-.458-.124 1.845-.185-.017-2.309-.215.208 2.31.017.185-1.846.119.452 1.793-.181.041-2.263.509.912 2.133.073.17-1.719.683.984 1.566-.159.095-2 1.184 1.527 1.746.122.14-1.422 1.18 1.42 1.185-.122.139L0 22.407l1.992 1.189.159.1-.989 1.563 1.717.689-.074.17-.919 2.13 2.262.516.181.041-.459 1.789 1.846.124-.018.185-.214 2.309 2.31-.207.185-.017.118 1.846 1.794-.453.041.181.509 2.264 2.133-.912.17-.073.684 1.72 1.566-.985.095.159 1.181 1.995 1.748-1.526.14-.122 1.181 1.423 1.185-1.42.146.123 1.738 1.53 1.189-1.991.095-.159 1.563.989.689-1.718.17.074 2.13.918.516-2.262.041-.18 1.792.458.124-1.846.185.017 2.31.215-.208-2.31-.017-.185 1.846-.119-.453-1.794.181-.04 2.263-.509-.911-2.133-.073-.171 1.719-.683-.984-1.566.159-.095 1.995-1.184-1.526-1.747-.122-.139 1.424-1.181-1.42-1.185.122-.14 1.531-1.742-1.989-1.192-.159-.1.989-1.563-1.717-.689.074-.17.918-2.131-2.262-.516-.181-.041.458-1.792-1.845-.124.017-.185.215-2.31-2.311.208-.185.017-.119-1.846-1.793.452-.041-.181-.508-2.263-2.129.921-.171.073-.683-1.719-1.566.985-.095-.16-1.184-2-1.751 1.534-.14.122L19.399.238l-1.185 1.416-.14-.122z",
      fill: "#8c7969"
    }, void 0), (0, jsx_runtime_1.jsxs)("g", Object.assign({
      "data-name": "Group 870"
    }, {
      children: [(0, jsx_runtime_1.jsx)("g", Object.assign({
        "data-name": "Group 867",
        clipPath: "url(#igiLogo_svg__a)"
      }, {
        children: (0, jsx_runtime_1.jsx)("path", {
          "data-name": "Path 568",
          d: "M36.789 21.064l-.122-.139-.157-.18-.13-.148-.129-.148-.922-1.06.925-1.052.13-.148.13-.148.157-.179.123-.139 1.112-1.265-1.446-.864-.159-.095-.205-.123-.169-.1-.169-.1-1.2-.718.554-1.286.078-.181.078-.181.095-.219.073-.17.667-1.547-1.643-.375-.181-.041-.233-.053-.192-.044-.192-.044-1.365-.311.13-1.394.018-.2.018-.2.022-.238.017-.185.156-1.677-1.677.151-.185.017-.238.021-.2.018-.2.018-1.394.126-.307-1.365-.043-.192-.044-.192-.053-.233-.04-.181-.37-1.643-1.549.662-.17.073-.22.094-.181.077-.181.077-1.288.55-.715-1.2-.1-.169-.1-.169-.122-.2-.094-.16-.86-1.449-1.268 1.108-.139.122-.18.157-.148.13-.148.129-1.054.921-1.047-.921-.148-.13-.148-.13-.179-.158-.14-.122L16.463.837l-.864 1.446-.1.159-.123.205-.1.169-.1.169-.718 1.2-1.286-.554-.181-.078-.181-.078-.22-.095-.17-.073-1.547-.667-.375 1.642-.041.181-.053.233-.039.193-.044.192-.308 1.363-1.394-.13-.2-.018-.2-.018-.238-.022-.185-.017-1.677-.156.152 1.677.017.185.021.238.018.2.018.2.126 1.394-1.366.307-.192.043-.192.043-.233.053-.175.034-1.643.37.662 1.549.073.171.094.219.077.181.078.181.55 1.287-1.2.714-.17.1-.169.1-.205.122-.16.1-1.449.86 1.108 1.268.122.14.157.18.13.148.13.148.921 1.054-.924 1.051-.13.148-.13.148-.158.18-.123.139L.842 22.28l1.446.863.159.1.205.122.17.1.168.1 1.2.718-.554 1.286-.078.181-.078.18-.095.219-.073.171-.667 1.547 1.642.375.181.041.233.053.192.044.192.044 1.365.311-.137 1.389-.019.2-.018.2-.022.238-.017.185-.157 1.677 1.678-.151.185-.017.238-.021.2-.018.2-.018 1.394-.126.307 1.366.043.192.044.192.052.233.041.181.37 1.643 1.548-.662.171-.073.22-.094.181-.077.181-.078 1.287-.55.714 1.2.1.169.1.17.122.206.094.159.86 1.449 1.266-1.11.14-.122.18-.157.149-.13.149-.13 1.054-.922 1.051.925.148.13.148.131.18.158.139.122 1.264 1.113.864-1.446.1-.159.122-.205.1-.169.1-.17.718-1.2 1.286.553.181.078.181.078.219.095.17.073 1.547.667.375-1.642.041-.18.053-.233.044-.192.044-.192.311-1.365 1.394.13.2.019.2.018.238.022.185.017 1.677.157-.15-1.678-.017-.185-.022-.238-.018-.2-.018-.2-.125-1.394 1.366-.307.191-.043.193-.043.233-.053.181-.041 1.644-.37-.673-1.546-.073-.171-.093-.219-.077-.181-.077-.181-.551-1.287 1.2-.714.169-.1.17-.1.205-.122.159-.095 1.448-.859zM3.964 19.346a15.407 15.407 0 1115.384 15.43 15.407 15.407 0 01-15.384-15.43",
          fill: "#8c7969"
        }, void 0)
      }), void 0), (0, jsx_runtime_1.jsx)("g", Object.assign({
        "data-name": "Group 868",
        clipPath: "url(#igiLogo_svg__a)"
      }, {
        children: (0, jsx_runtime_1.jsx)("path", {
          "data-name": "Path 569",
          d: "M34.11 19.393a14.741 14.741 0 10-14.762 14.718A14.757 14.757 0 0034.11 19.393m-29.25-.044a14.509 14.509 0 1114.488 14.53A14.526 14.526 0 014.86 19.348",
          fill: "#8c7969"
        }, void 0)
      }), void 0), (0, jsx_runtime_1.jsx)("g", Object.assign({
        "data-name": "Group 869",
        clipPath: "url(#igiLogo_svg__a)"
      }, {
        children: (0, jsx_runtime_1.jsx)("path", {
          "data-name": "Path 570",
          d: "M19.329 23.844l-.027.026.04.036.069-.062z",
          fill: "#8c7969"
        }, void 0)
      }), void 0)]
    }), void 0), (0, jsx_runtime_1.jsxs)("g", Object.assign({
      "data-name": "Group 871",
      fill: "#8d7967"
    }, {
      children: [(0, jsx_runtime_1.jsx)("path", {
        "data-name": "Path 571",
        d: "M17.184 32.578h-.382V30.85h-.354v-.3h.735z"
      }, void 0), (0, jsx_runtime_1.jsx)("path", {
        "data-name": "Path 572",
        d: "M18.462 32.577h-.414l.46-.691c-.036.007-.066.013-.089.016a.456.456 0 01-.065 0 .54.54 0 01-.423-.2.714.714 0 01-.173-.486.67.67 0 01.047-.24.777.777 0 01.127-.22.708.708 0 01.242-.19.717.717 0 01.3-.061.724.724 0 01.276.053.692.692 0 01.23.153.715.715 0 01.153.226.651.651 0 01.054.259.84.84 0 01-.058.3 2.228 2.228 0 01-.227.4zm.345-1.338a.369.369 0 00-.1-.258.306.306 0 00-.234-.106.312.312 0 00-.238.1.391.391 0 000 .506.305.305 0 00.234.1.322.322 0 00.238-.1.33.33 0 00.101-.242z"
      }, void 0), (0, jsx_runtime_1.jsx)("path", {
        "data-name": "Path 573",
        d: "M19.912 32.578h-.405l.756-1.671h-.792v-.356h1.16v.376z"
      }, void 0)]
    }), void 0), (0, jsx_runtime_1.jsx)("g", Object.assign({
      "data-name": "Group 872"
    }, {
      children: (0, jsx_runtime_1.jsx)("path", {
        "data-name": "Path 574",
        d: "M22.068 30.55v.351h-.7l-.062.348a.531.531 0 01.132-.054.578.578 0 01.146-.018.632.632 0 01.477.209.737.737 0 01.15.759.738.738 0 01-.136.224.715.715 0 01-.244.189.7.7 0 01-.3.063.682.682 0 01-.487-.187.726.726 0 01-.223-.487h.381a.351.351 0 00.107.221.308.308 0 00.219.085.3.3 0 00.232-.1.379.379 0 00.093-.263.352.352 0 00-.093-.254.328.328 0 00-.247-.1.318.318 0 00-.158.037.276.276 0 00-.106.109l-.337-.077.194-1.055z",
        fill: "#8d7967"
      }, void 0)
    }), void 0), (0, jsx_runtime_1.jsx)("g", Object.assign({
      "data-name": "Group 873"
    }, {
      children: (0, jsx_runtime_1.jsx)("path", {
        "data-name": "Path 575",
        d: "M13.037 28.84l-1.14 1.646-.314-.217 1.14-1.646z",
        fill: "#8d7967"
      }, void 0)
    }), void 0), (0, jsx_runtime_1.jsx)("g", Object.assign({
      "data-name": "Group 874"
    }, {
      children: (0, jsx_runtime_1.jsx)("path", {
        "data-name": "Path 576",
        d: "M12.299 28.332l-1.35 1.478-.316-.288.343-1.621.033-.062-1.01 1.106-.285-.26 1.35-1.478.315.287-.337 1.615-.029.066 1-1.1z",
        fill: "#8d7967"
      }, void 0)
    }), void 0), (0, jsx_runtime_1.jsx)("g", Object.assign({
      "data-name": "Group 875"
    }, {
      children: (0, jsx_runtime_1.jsx)("path", {
        "data-name": "Path 577",
        d: "M10.608 26.671l-1.279 1.032.238.295-.28.226-.72-.89.28-.226.241.3 1.279-1.032z",
        fill: "#8d7967"
      }, void 0)
    }), void 0), (0, jsx_runtime_1.jsx)("g", Object.assign({
      "data-name": "Group 876"
    }, {
      children: (0, jsx_runtime_1.jsx)("path", {
        "data-name": "Path 578",
        d: "M9.94 25.807l-1.7 1.053-.586-.94.306-.189.381.616.393-.243-.364-.589.306-.189.364.589.394-.243-.381-.616.306-.189z",
        fill: "#8d7967"
      }, void 0)
    }), void 0), (0, jsx_runtime_1.jsx)("g", Object.assign({
      "data-name": "Group 877"
    }, {
      children: (0, jsx_runtime_1.jsx)("path", {
        "data-name": "Path 579",
        d: "M9.153 24.489l-1.837.8-.238-.547a1.306 1.306 0 01-.1-.3.577.577 0 01.013-.242.631.631 0 01.133-.249.611.611 0 01.221-.167.652.652 0 01.236-.051.639.639 0 01.235.031.542.542 0 01.163.09.881.881 0 01.161.17l.456-.806.187.431-.489.8.7-.306zm-1.115.069l-.083-.191a.485.485 0 00-.189-.241.261.261 0 00-.245-.006.272.272 0 00-.163.192.308.308 0 00-.005.125.824.824 0 00.056.163l.084.194z",
        fill: "#8d7967"
      }, void 0)
    }), void 0), (0, jsx_runtime_1.jsx)("g", Object.assign({
      "data-name": "Group 878"
    }, {
      children: (0, jsx_runtime_1.jsx)("path", {
        "data-name": "Path 580",
        d: "M8.483 22.894l-1.945.479-.1-.416 1.187-1.158.062-.033-1.455.358-.092-.374 1.945-.479.1.413-1.179 1.156-.061.039 1.446-.356z",
        fill: "#8d7967"
      }, void 0)
    }), void 0), (0, jsx_runtime_1.jsx)("g", Object.assign({
      "data-name": "Group 879"
    }, {
      children: (0, jsx_runtime_1.jsx)("path", {
        "data-name": "Path 581",
        d: "M8.032 20.977l-2.046-.748-.016-.3 1.954-.973.022.419-.5.251.039.73.528.2zm-.877-.7l-.027-.5-.611.274-.074.013h.075z",
        fill: "#8d7967"
      }, void 0)
    }), void 0), (0, jsx_runtime_1.jsx)("g", Object.assign({
      "data-name": "Group 880"
    }, {
      children: (0, jsx_runtime_1.jsx)("path", {
        "data-name": "Path 582",
        d: "M7.987 18.431l-1.636-.16-.037.377-.358-.035.112-1.139.358.035-.038.382 1.636.16z",
        fill: "#8d7967"
      }, void 0)
    }), void 0), (0, jsx_runtime_1.jsx)("g", Object.assign({
      "data-name": "Group 881"
    }, {
      children: (0, jsx_runtime_1.jsx)("path", {
        "data-name": "Path 583",
        d: "M8.127 17.363l-1.965-.388.074-.374 1.965.388z",
        fill: "#8d7967"
      }, void 0)
    }), void 0), (0, jsx_runtime_1.jsx)("g", Object.assign({
      "data-name": "Group 882"
    }, {
      children: (0, jsx_runtime_1.jsx)("path", {
        "data-name": "Path 584",
        d: "M6.687 14.894a1.123 1.123 0 01.317-.474 1.037 1.037 0 01.491-.245 1.01 1.01 0 01.547.041.994.994 0 01.443.311 1.049 1.049 0 01.225.5 1.108 1.108 0 01-.362 1.014 1.054 1.054 0 01-.49.242 1.019 1.019 0 01-.984-.349 1.068 1.068 0 01-.231-.493 1.025 1.025 0 01.044-.547zm.35.089a.726.726 0 00-.036.366.668.668 0 00.146.322.656.656 0 00.293.2.666.666 0 00.356.027.7.7 0 00.324-.154.675.675 0 00.231-.647.706.706 0 00-.154-.325.661.661 0 00-.291-.2.652.652 0 00-.348-.026.7.7 0 00-.319.151.654.654 0 00-.2.284z",
        fill: "#8d7967"
      }, void 0)
    }), void 0), (0, jsx_runtime_1.jsx)("g", Object.assign({
      "data-name": "Group 883"
    }, {
      children: (0, jsx_runtime_1.jsx)("path", {
        "data-name": "Path 585",
        d: "M9.159 14.213l-1.715-1.032.221-.367 1.659.017.067.02-1.283-.771.2-.33 1.716 1.032-.22.365-1.651-.012-.07-.016 1.276.767z",
        fill: "#8d7967"
      }, void 0)
    }), void 0), (0, jsx_runtime_1.jsx)("g", Object.assign({
      "data-name": "Group 884"
    }, {
      children: (0, jsx_runtime_1.jsx)("path", {
        "data-name": "Path 586",
        d: "M10.207 12.523l-.92-1.973.2-.223 2.071.687-.28.313-.534-.177-.488.545.232.515zm-.125-1.116l.335-.375-.626-.236-.061-.043.05.056z",
        fill: "#8d7967"
      }, void 0)
    }), void 0), (0, jsx_runtime_1.jsx)("g", Object.assign({
      "data-name": "Group 885"
    }, {
      children: (0, jsx_runtime_1.jsx)("path", {
        "data-name": "Path 587",
        d: "M11.797 10.827l-1.271-1.552.3-.242 1.041 1.269.486-.4.228.278z",
        fill: "#8d7967"
      }, void 0)
    }), void 0), (0, jsx_runtime_1.jsx)("g", Object.assign({
      "data-name": "Group 886"
    }, {
      children: (0, jsx_runtime_1.jsx)("path", {
        "data-name": "Path 588",
        d: "M14.798 7.358l-.415.2a.927.927 0 00-.15-.058.625.625 0 00-.138-.017.733.733 0 00-.317.067.722.722 0 00-.411.571.634.634 0 00.292.611.742.742 0 00.351.116.713.713 0 00.365-.067.677.677 0 00.341-.359.7.7 0 00.055-.227l-.782.368-.148-.315 1.218-.574.018.038a.957.957 0 01.087.529 1.055 1.055 0 01-.2.508 1.174 1.174 0 01-1 .469 1.068 1.068 0 01-.525-.171.976.976 0 01-.357-.407.989.989 0 01-.09-.538 1.073 1.073 0 01.2-.518 1.114 1.114 0 01.437-.362 1.136 1.136 0 01.277-.089 1.163 1.163 0 01.295-.017 1.121 1.121 0 01.286.058 1.14 1.14 0 01.311.184z",
        fill: "#8d7967"
      }, void 0)
    }), void 0), (0, jsx_runtime_1.jsx)("g", Object.assign({
      "data-name": "Group 887"
    }, {
      children: (0, jsx_runtime_1.jsx)("path", {
        "data-name": "Path 589",
        d: "M15.85 8.508l-.527-1.93 1.068-.292.095.346-.7.191.122.445.669-.183.094.346-.669.183.122.446.7-.191.094.346z",
        fill: "#8d7967"
      }, void 0)
    }), void 0), (0, jsx_runtime_1.jsx)("g", Object.assign({
      "data-name": "Group 888"
    }, {
      children: (0, jsx_runtime_1.jsx)("path", {
        "data-name": "Path 590",
        d: "M17.326 8.11l-.171-1.994.518-.045.681 1.429.034.117.013-.121.383-1.521.518-.045.171 1.994-.38.033-.128-1.493-.4 1.54-.323.028-.658-1.448.128 1.493z",
        fill: "#8d7967"
      }, void 0)
    }), void 0), (0, jsx_runtime_1.jsx)("g", Object.assign({
      "data-name": "Group 889"
    }, {
      children: (0, jsx_runtime_1.jsx)("path", {
        "data-name": "Path 591",
        d: "M21.122 6.048a1.125 1.125 0 01.53.211 1.037 1.037 0 01.342.429 1.006 1.006 0 01.073.543.994.994 0 01-.212.5 1.053 1.053 0 01-.44.324 1.11 1.11 0 01-1.068-.143 1.053 1.053 0 01-.339-.428 1.015 1.015 0 01.138-1.034 1.07 1.07 0 01.435-.329 1.028 1.028 0 01.541-.073zm-.015.36a.726.726 0 00-.366.041.667.667 0 00-.286.209.678.678 0 00-.091.682.7.7 0 00.218.284.678.678 0 00.682.091.712.712 0 00.286-.218.662.662 0 00.14-.327.649.649 0 00-.047-.346.693.693 0 00-.214-.28.649.649 0 00-.322-.135z",
        fill: "#8d7967"
      }, void 0)
    }), void 0), (0, jsx_runtime_1.jsx)("g", Object.assign({
      "data-name": "Group 890"
    }, {
      children: (0, jsx_runtime_1.jsx)("path", {
        "data-name": "Path 592",
        d: "M22.311 8.363l.591-1.912.365.112-.485 1.569.6.185-.106.343z",
        fill: "#8d7967"
      }, void 0)
    }), void 0), (0, jsx_runtime_1.jsx)("g", Object.assign({
      "data-name": "Group 891"
    }, {
      children: (0, jsx_runtime_1.jsx)("path", {
        "data-name": "Path 593",
        d: "M25.337 7.34a1.124 1.124 0 01.432.371 1.036 1.036 0 01.184.517 1.006 1.006 0 01-.108.537.992.992 0 01-.363.4 1.05 1.05 0 01-.521.164 1.109 1.109 0 01-.963-.482 1.055 1.055 0 01-.181-.515.993.993 0 01.1-.531 1 1 0 01.362-.4 1.071 1.071 0 01.518-.17 1.03 1.03 0 01.54.109zm-.131.336a.726.726 0 00-.36-.079.671.671 0 00-.338.105.658.658 0 00-.237.266.666.666 0 00-.07.349.7.7 0 00.113.34.676.676 0 00.615.307.711.711 0 00.341-.113.661.661 0 00.238-.264.65.65 0 00.068-.342.7.7 0 00-.112-.334.647.647 0 00-.259-.235z",
        fill: "#8d7967"
      }, void 0)
    }), void 0), (0, jsx_runtime_1.jsx)("g", Object.assign({
      "data-name": "Group 892"
    }, {
      children: (0, jsx_runtime_1.jsx)("path", {
        "data-name": "Path 594",
        d: "M28.174 10.008l-.358-.286a.978.978 0 00-.014-.161.629.629 0 00-.046-.131.733.733 0 00-.2-.254.722.722 0 00-.693-.116.635.635 0 00-.421.532.739.739 0 00.05.366.714.714 0 00.221.3.68.68 0 00.473.147.705.705 0 00.229-.051l-.675-.538.217-.272 1.052.839-.026.033a.96.96 0 01-.437.311 1.055 1.055 0 01-.545.044 1.17 1.17 0 01-.863-.689 1.063 1.063 0 01-.078-.547.974.974 0 01.208-.5.991.991 0 01.444-.318 1.073 1.073 0 01.553-.049 1.132 1.132 0 01.719.442 1.157 1.157 0 01.145.256.967.967 0 01.044.644z",
        fill: "#8d7967"
      }, void 0)
    }), void 0), (0, jsx_runtime_1.jsx)("g", Object.assign({
      "data-name": "Group 893"
    }, {
      children: (0, jsx_runtime_1.jsx)("path", {
        "data-name": "Path 595",
        d: "M27.586 11.467l1.465-1.365.26.279-1.465 1.365z",
        fill: "#8d7967"
      }, void 0)
    }), void 0), (0, jsx_runtime_1.jsx)("g", Object.assign({
      "data-name": "Group 894"
    }, {
      children: (0, jsx_runtime_1.jsx)("path", {
        "data-name": "Path 596",
        d: "M29.505 13.007l.255.363a1.429 1.429 0 01-.195.018.907.907 0 01-.163-.016 1.107 1.107 0 01-.678-.446 1.052 1.052 0 01-.189-.518 1.064 1.064 0 01.09-.541 1 1 0 01.347-.419.993.993 0 01.508-.179 1.072 1.072 0 01.953.455 1.1 1.1 0 01.172.387 1.068 1.068 0 01.015.418.744.744 0 01-.038.157 1.645 1.645 0 01-.088.186l-.249-.356a1.058 1.058 0 00.021-.16.75.75 0 00-.127-.426.647.647 0 00-.27-.223.7.7 0 00-.348-.06.663.663 0 00-.332.12.653.653 0 00-.225.272.707.707 0 00-.062.349.65.65 0 00.117.33.66.66 0 00.189.179.711.711 0 00.132.066 1.1 1.1 0 00.165.044z",
        fill: "#8d7967"
      }, void 0)
    }), void 0), (0, jsx_runtime_1.jsx)("g", Object.assign({
      "data-name": "Group 895"
    }, {
      children: (0, jsx_runtime_1.jsx)("path", {
        "data-name": "Path 597",
        d: "M29.387 13.823l2.179-.028.121.274-1.48 1.6-.17-.384.382-.413-.3-.668h-.565zm1.07.344l.2.459.474-.473.064-.039-.072.022z",
        fill: "#8d7967"
      }, void 0)
    }), void 0), (0, jsx_runtime_1.jsx)("g", Object.assign({
      "data-name": "Group 896"
    }, {
      children: (0, jsx_runtime_1.jsx)("path", {
        "data-name": "Path 598",
        d: "M30.258 15.984l1.933-.524.1.368-1.587.43.164.606-.347.094z",
        fill: "#8d7967"
      }, void 0)
    }), void 0), (0, jsx_runtime_1.jsx)("g", Object.assign({
      "data-name": "Group 897"
    }, {
      children: (0, jsx_runtime_1.jsx)("path", {
        "data-name": "Path 599",
        d: "M30.72 18.203l2-.172.033.38-2 .172z",
        fill: "#8d7967"
      }, void 0)
    }), void 0), (0, jsx_runtime_1.jsx)("g", Object.assign({
      "data-name": "Group 898"
    }, {
      children: (0, jsx_runtime_1.jsx)("path", {
        "data-name": "Path 600",
        d: "M30.804 19.104l2 .1-.021.427-1.469.77-.069.014 1.5.073-.019.385-2-.1.021-.425 1.461-.77.069-.02-1.488-.072z",
        fill: "#8d7967"
      }, void 0)
    }), void 0), (0, jsx_runtime_1.jsx)("g", Object.assign({
      "data-name": "Group 899"
    }, {
      children: (0, jsx_runtime_1.jsx)("path", {
        "data-name": "Path 601",
        d: "M31.211 21.214l-.084.39a.263.263 0 00-.2.042.287.287 0 00-.109.18.274.274 0 00.03.207.243.243 0 00.164.114.257.257 0 00.223-.048.8.8 0 00.178-.232l.042-.075a1.037 1.037 0 01.112-.151.556.556 0 01.238-.148.533.533 0 01.278-.013.527.527 0 01.26.139.578.578 0 01.155.258.619.619 0 01.01.309.643.643 0 01-.135.282.556.556 0 01-.243.168.613.613 0 01-.306.025l.083-.384a.22.22 0 00.164-.038.231.231 0 00.089-.145.194.194 0 00-.026-.156.206.206 0 00-.135-.087.191.191 0 00-.153.025.562.562 0 00-.145.176l-.047.08a1.086 1.086 0 01-.217.274.546.546 0 01-.484.118.618.618 0 01-.3-.155.634.634 0 01-.176-.286.68.68 0 01-.013-.346.67.67 0 01.3-.438.555.555 0 01.218-.088.6.6 0 01.229.003z",
        fill: "#8d7967"
      }, void 0)
    }), void 0), (0, jsx_runtime_1.jsx)("g", Object.assign({
      "data-name": "Group 900"
    }, {
      children: (0, jsx_runtime_1.jsx)("path", {
        "data-name": "Path 602",
        d: "M30.197 22.973l1.55.545.126-.358.339.119-.381 1.08-.339-.119.128-.362-1.55-.545z",
        fill: "#8d7967"
      }, void 0)
    }), void 0), (0, jsx_runtime_1.jsx)("g", Object.assign({
      "data-name": "Group 901"
    }, {
      children: (0, jsx_runtime_1.jsx)("path", {
        "data-name": "Path 603",
        d: "M29.804 23.988l1.816.844-.161.346-1.816-.844z",
        fill: "#8d7967"
      }, void 0)
    }), void 0), (0, jsx_runtime_1.jsx)("g", Object.assign({
      "data-name": "Group 902"
    }, {
      children: (0, jsx_runtime_1.jsx)("path", {
        "data-name": "Path 604",
        d: "M29.293 24.975l1.408.847.2-.325.308.185-.591.981-.308-.185.2-.329-1.408-.847z",
        fill: "#8d7967"
      }, void 0)
    }), void 0), (0, jsx_runtime_1.jsx)("g", Object.assign({
      "data-name": "Group 903"
    }, {
      children: (0, jsx_runtime_1.jsx)("path", {
        "data-name": "Path 605",
        d: "M30.323 27.14l-.237.3-.98-.775a1.543 1.543 0 00-.138-.1.334.334 0 00-.1-.037.313.313 0 00-.169.011.289.289 0 00-.133.095.308.308 0 00-.062.142.286.286 0 00.012.151.309.309 0 00.061.106 1.175 1.175 0 00.139.124l.979.775-.239.3-.979-.775a1.2 1.2 0 01-.229-.225.6.6 0 01-.1-.23.706.706 0 01.005-.31.651.651 0 01.357-.459.769.769 0 01.292-.084.6.6 0 01.258.041 1.214 1.214 0 01.282.176z",
        fill: "#8d7967"
      }, void 0)
    }), void 0), (0, jsx_runtime_1.jsx)("g", Object.assign({
      "data-name": "Group 904"
    }, {
      children: (0, jsx_runtime_1.jsx)("path", {
        "data-name": "Path 606",
        d: "M27.373 27.505l1.133 1.189.275-.261.248.26-.83.79-.248-.26.279-.265-1.133-1.189z",
        fill: "#8d7967"
      }, void 0)
    }), void 0), (0, jsx_runtime_1.jsx)("g", Object.assign({
      "data-name": "Group 905"
    }, {
      children: (0, jsx_runtime_1.jsx)("path", {
        "data-name": "Path 607",
        d: "M26.567 28.221l1.187 1.611-.892.656-.213-.289.584-.43-.274-.371-.558.411-.213-.289.558-.411-.275-.372-.584.43-.213-.289z",
        fill: "#8d7967"
      }, void 0)
    }), void 0)]
  }), void 0)]
}), void 0);

exports.default = SvgIgiLogo;